import DateInput from "@/components/DateInput";

const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const PERIOD_PRESETS = [
  { key: "month", label: "Luna curentă" },
  { key: "last_month", label: "Luna trecută" },
  { key: "year", label: "Anul curent" },
  { key: "all", label: "Tot" },
  { key: "custom", label: "Personalizat" },
];

export function presetRange(key) {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  if (key === "month") return { from: ymd(new Date(y, m, 1)), to: ymd(new Date(y, m + 1, 0)) };
  if (key === "last_month") return { from: ymd(new Date(y, m - 1, 1)), to: ymd(new Date(y, m, 0)) };
  if (key === "year") return { from: `${y}-01-01`, to: `${y}-12-31` };
  return { from: "", to: "" };
}

export function SalesPeriodFilter({ period, onChange, prefix = "sales-period" }) {
  function pick(key) {
    if (key === "custom") onChange({ ...period, preset: "custom" });
    else onChange({ preset: key, ...presetRange(key) });
  }
  return (
    <div className="space-y-3" data-testid={`${prefix}-filter`}>
      <div className="flex flex-wrap gap-2">
        {PERIOD_PRESETS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => pick(p.key)}
            data-testid={`${prefix}-preset-${p.key}`}
            className={`text-xs font-medium px-3 py-1.5 rounded-full border transition-colors ${
              period.preset === p.key
                ? "bg-slate-900 text-white border-slate-900"
                : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      {period.preset === "custom" && (
        <div className="grid grid-cols-2 gap-2 max-w-md">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">De la</div>
            <DateInput value={period.from} onChange={(v) => onChange({ ...period, from: v })} testid={`${prefix}-from`} />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Până la</div>
            <DateInput value={period.to} onChange={(v) => onChange({ ...period, to: v })} testid={`${prefix}-to`} />
          </div>
        </div>
      )}
    </div>
  );
}
